<script lang="ts">
	import { create } from "@bufbuild/protobuf";
	import { A, Heading, Hr, Img } from "flowbite-svelte";
	import { getContext } from "svelte";
	import type { Suite } from "#gen/bundles/v1/bundle_pb.js";
	import { CommerceDataSchema } from "#gen/bundles/v1/commerce_pb.js";
	import type { Product } from "#gen/products/v1/product_pb.js";
	import { RecommendationType } from "#gen/products/v1/service_pb.js";
	import type { ProductClient } from "#lib/api/products.js";
	import P from "#lib/components/P.svelte";
	import type { ComponentProps } from "#lib/components/page/ComponentProps.js";
	import { formatPriceRange } from "#lib/money.js";
	import { numberValue, structValue } from "#lib/struct.js";
	import type { Writable } from "svelte/store";

	type Props = ComponentProps;

	const productClient: ProductClient = getContext("productClient");
	const pageState: Writable<{ suite: Writable<Suite> }> = getContext("pageState");
	const suite: Writable<Suite> = $pageState.suite;

	let { id, page, readOnly = false }: Props = $props();

	let commerce = $derived($suite.data?.type.case === "commerce" ? $suite.data?.type.value : create(CommerceDataSchema, {}));
	let config = $derived(structValue($page.config, id));
	let recommendationType = $derived((numberValue(config, "recommendation_type") as RecommendationType) ?? RecommendationType.RELATED);

	function productURL(product: Product): string {
		return `${commerce?.integration?.url}/products/${product.handle}`;
	}
</script>

{#if commerce?.integration && commerce?.product}
	{#await productClient.getRecommendations(commerce?.integration.id, commerce?.product.id, recommendationType) then products}
		<div class="my-4">
			{#each products as product, i (product.id)}
				{#if i > 0}
					<Hr hrClass="my-4" />
				{/if}
				<div class="flex gap-4">
					<div class="w-16 flex-none">
						<Img class="rounded-lg border" src={product?.featuredImage?.url} />
					</div>
					<div class="grow">
						<A color="" href={productURL(product)} target="_blank" class={readOnly ? "pointer-events-none" : ""}>
							<Heading tag="h6" class="text-md tracking-tight">{product?.title}</Heading>
						</A>
						<P weight="medium" size="sm" class="my-1">{formatPriceRange(product?.priceRange)}</P>
						<P weight="light" size="sm" class="my-1">{product?.description}</P>
					</div>
				</div>
			{:else}
				<P align="center" class="mt-8">There are currently no reommendations for this product</P>
			{/each}
		</div>
	{:catch error}
		<p class="text-red-700">{error.message}</p>
	{/await}
{:else}
	<P align="center" class="mt-8">Please select a product integration and product to see recommendations</P>
{/if}
